import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { MISCELLANEOUS_RESOURCES } from 'constant';
import { URL, LABEL, IMAGE_SOURCE, CONFISCATION_RESOURCES } from './helper';
import { keyHeading, subKeyHeading } from './style';

const useMiscellaneousHome = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (configResourceName: string) => {
		return hasPermissionV2({
			configPageName: MISCELLANEOUS_RESOURCES.confiscationAndRefund,
			configResourceName
		});
	};

	return { isEnabled };
};

const SelectConfiscationHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useMiscellaneousHome();

	return (
		<div className={css(keyHeading)}>
			{_map(_keys(CONFISCATION_RESOURCES), (resourceName) => {
				return isEnabled(resourceName) ? (
					<div
						key={resourceName}
						className={css(subKeyHeading)}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[resourceName]);
						}}>
						<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default SelectConfiscationHome;
